import { defineComponent as _defineComponent } from 'vue'
import { Tooltip } from '@/ui/components/Tooltip';
  import { hasAiBalance as hasAiBalanceComputed } from '@/ui/auth/auth';
  import { t } from '@/ui/i18n/i18n';

  interface PredefinedMessage {
    id: string;
    key: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AiChatPredefinedMessages',
  emits: ['message-click'],
  setup(__props, { emit }) {

  

  const predefinedMessages: PredefinedMessage[] = [
    { id: '1', key: 'analytics.ai-chat-presets.last-week-submissions' },
    { id: '2', key: 'analytics.ai-chat-presets.top-user-this-month' },
    { id: '3', key: 'analytics.ai-chat-presets.top-entities-by-submissions' },
    { id: '4', key: 'analytics.ai-chat-presets.top-user-overdue-actions' },
    { id: '5', key: 'analytics.ai-chat-presets.avg-score-per-category' },
  ];

  const resolveMessage = (message: PredefinedMessage) => t(message.key);

  const handleMessageClick = (messageText: string) => {
    emit('message-click', messageText);
  };

  const onClick = (message: PredefinedMessage) => {
    if (!hasAiBalanceComputed.value) {
      return;
    }
    handleMessageClick(resolveMessage(message));
  };

return { __sfc: true,emit, predefinedMessages, resolveMessage, handleMessageClick, onClick, Tooltip, hasAiBalanceComputed }
}

})